export * from './base-folder-tree-page.component'
export * from './base-folder-tree.service'
export * from './base-folder.component'
export * from './folder-form.component'

import { FolderFormComponent } from './folder-form.component'

export const FOLDER_TREE_COMPONENTS = [
  FolderFormComponent
]


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/common/folder-tree/index.ts